<template>
  <div id='about'>

    <AboutContent></AboutContent>

  </div>
</template>
<script>
import AboutContent from '../components/about/AboutContent'
export default {
  name: 'about',
  components: {
    AboutContent,
  },
}
</script>
<style scoped>
</style>



// WEBPACK FOOTER //
// src/page/About.vue